__turbopack_context__.v({
  "selectedEntity": "SelectedEntity-module__Wprlia__selectedEntity",
  "selectedEntityContainer": "SelectedEntity-module__Wprlia__selectedEntityContainer",
  "selectedEntity__header": "SelectedEntity-module__Wprlia__selectedEntity__header",
});
